import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, data }) => {
  switch (type) {
    case types.GET_CSV_REPORT_FAILURE:
    case types.GET_REPORT_FAILURE:
      return {
        title: t('message.title.error.get.report'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
